import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Button, Typography } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: 16,
    color: theme.palette.primary.main,
  },
});

const LinkButton = ({
  className,
  classes,
  icon,
  label,
  disabled,
  onClick,
}) => {
  return (
    <Button
      className={classNames(classes.root, className)}
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      <Typography>{label}</Typography>
    </Button>
  );
};

LinkButton.defaultProps = {
  className: '',
};

LinkButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(LinkButton);
